import React from 'react';
import { Routes, Route } from "react-router-dom";
import WorkflowReportModule from './workflow-reports-module/workflow-reports-module';
import ReportSubmission from './workflow-reports-module/report-submission/report-submission';
import CertificationOfHoldingsReportModule from './certification-of-holdings-module/certification-of-holdings-module';

const WorkflowReports = () => {
  return (
    <Routes>
      <Route index element={<WorkflowReportModule />} />
      <Route path="certification-of-holdings" element={<CertificationOfHoldingsReportModule />} />
      <Route path="application" element={<ReportSubmission />} />
      <Route path="application/:applicationId/:isin/:bpId/:reportHash/:interestPaymentDate" element={<ReportSubmission />} />
    </Routes>
  )
}

export default WorkflowReports;
